import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 5, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-testimonial-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 1, spaceBetween: 30 },
        992: { slidesPerView: 1, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <main>
      <section className="w-full py-3 relative overflow-hidden pt-24 flex justify-center bg-white max-md:pt-[4rem]" data-aos="fade">
        <div className="relative w-full max-w-[1860px] overflow-hidden bg-hero rounded-[20px]">
          {/* content start */}
          <div className="theme-container w-full mx-auto">
            <div className="grid grid-cols-6 xl:grid-cols-12 z-10 py-[70px] lg:pt-[120px] lg:pb-[120px]">
              <div className="col-span-6 my-auto">
                <div data-aos="fade" className="flex gap-2.5 relative z-10 px-3 sm:px-6 py-1.5 sm:py-3 rounded-[40px] border border-white/10 bg-white/5 items-center w-fit">
                  <svg
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_460_33032)">
                      <path
                        d="M10.0005 10.9371L0.0507812 7.62184C0.132029 7.4156 0.3164 7.26529 0.535144 7.23435L6.68811 6.32812L10.0005 10.9371Z"
                        fill="#FEC461"
                      />
                      <path
                        d="M9.99999 10.937V16.6775L4.497 19.6149C4.28451 19.7274 4.0317 19.709 3.83765 19.5649L9.99999 10.937Z"
                        fill="#F7B84E"
                      />
                      <path
                        d="M10.0005 10.937L3.83784 19.5646C3.64753 19.4243 3.55035 19.1837 3.59128 18.9431L4.64094 12.7248L10.0005 10.937Z"
                        fill="#FEC461"
                      />
                      <path
                        d="M10 10.9368L4.64079 12.7246L0.190595 8.31813C0.0190365 8.14938 -0.0437743 7.89595 0.0312237 7.66814C0.0377861 7.65252 0.0405985 7.63658 0.0502858 7.62158L10 10.9368Z"
                        fill="#F7B84E"
                      />
                      <path
                        d="M10 0.312012V10.9367L6.68762 6.32748L9.44068 0.665128C9.5438 0.449196 9.76254 0.312012 10 0.312012Z"
                        fill="#FEC461"
                      />
                      <path
                        d="M13.3124 6.32748L10 10.9367V0.312012C10.2375 0.312012 10.4562 0.449196 10.5594 0.665128L13.3124 6.32748Z"
                        fill="#F7B84E"
                      />
                      <path
                        d="M19.9497 7.62167L10 10.9369L13.3124 6.32764L19.4654 7.23386C19.6841 7.26511 19.8685 7.41511 19.9497 7.62167Z"
                        fill="#FEC461"
                      />
                      <path
                        d="M19.8123 8.31813L15.3592 12.7246L10 10.9368L19.9497 7.62158C19.9591 7.63689 19.9622 7.65283 19.9688 7.66814C20.0435 7.89626 19.981 8.14938 19.8123 8.31813Z"
                        fill="#F7B84E"
                      />
                      <path
                        d="M16.1623 19.5646L10 10.937L15.3592 12.7248L16.4092 18.9431C16.4498 19.184 16.353 19.4243 16.1623 19.5646Z"
                        fill="#FEC461"
                      />
                      <path
                        d="M16.1623 19.5646C15.9686 19.7087 15.7155 19.7274 15.5033 19.6146L10 16.6775V10.937L16.1623 19.5646Z"
                        fill="#F7B84E"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_460_33032">
                        <rect width={20} height={20} fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="font-semibold text-18 sm:text-20 text-white">
                    Click. Connect. Care
                  </span>
                </div>
                <h1 data-aos="fade" data-aos-delay={100}
                  className="text-4xl md:text-[65px] leading-[1.4em] tracking-tight font-semibold text-white pr-2 mt-7 max-w-[586px] relative z-10"
                  data-depth="-0.28"
                >
                  Comprehensive OPD Plans for Everyday Care
                </h1>
                <p data-aos="fade" data-aos-delay={200} className="text-18 font-medium text-white mt-5 md:mt-5 max-w-[580px] relative z-10">
                  Our OPD plans are designed to provide you with seamless access
                  to medical consultations, diagnostics, and wellness
                  services—all without the hassle of long waits or complex
                  procedures.
                </p>
                
                <div data-aos="fade" data-aos-delay={300} className="flex flex-col sm:flex-row gap-3 sm:gap-6 mt-5 md:mt-12">
                  <a href="/plans">
                    <div className="home-two-btn-bg py-2.5 group bg-mainBtn border-none">
                      <span className="text-base text-white group-hover:text-[#F30A02] transition-all duration-300 font-semibold py-1 relative z-10">
                        Explore Plans
                      </span>
                      <svg
                        className="relative z-10"
                        width={7}
                        height={12}
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="group-hover:stroke-[#F30A02] stroke-white transition-all duration-300"
                          d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </a>
                  {/* <a href="/contact">
                    <div className="home-two-btn-bg py-2.5 group bg-[#ffffff] before:bg-it-blue after:bg-it-blue border-none">
                      <span className="text-base text-[#F30A02] group-hover:text-[#ffffff] transition-all duration-300 font-semibold py-1 relative z-10">
                        Talk to an Expert
                      </span>
                      <svg
                        className="relative z-10"
                        width={7}
                        height={12}
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="group-hover:stroke-white stroke-[#F30A02] transition-all duration-300"
                          d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* content end  */}
      </section>

      {/* about start  */}
      <section className="py-[100px] bg-white">
        <div className="theme-container mx-auto grid grid-cols-6 lg:grid-cols-12 sm:gap-[63px]">
          <div className="col-span-6">
            <h1 data-aos="fade" className="border text-theme border-buisness-red/10 pt-1 py-0.5 px-5 rounded-[30px] w-fit bg-theme font-medium">
              About Us
            </h1>
            <h2 data-aos="fade" data-aos-delay={100} className="font-semibold text-2xl sm:text-[42px] leading-[1.4em] text-main-black mt-5">
              Bringing Healthcare to Your Fingertips — Click, Connect, and Care
              Without the Wait
            </h2>
            <p data-aos="fade" data-aos-delay={200} className="text-black font-semibold mt-6">
              At ClickForDoctor, we believe that healthcare should be simple,
              fast, and accessible. Our platform empowers patients to connect
              with licensed medical professionals with just a few clicks.
            </p>
            <p data-aos="fade" data-aos-delay={300} className="text-paragraph mt-4">
              Through our seamless Click • Care • Connect approach, we bring
              consultations, expert advice, and ongoing care to your
              fingertips—whenever you need it, wherever you are.
            </p>
            <p data-aos="fade" data-aos-delay={400} className="text-paragraph mt-4">
              At ClickForDoctor, we believe that healthcare should be simple,
              fast, and accessible. Our platform empowers patients to connect
              with licensed medical professionals with just a few clicks.
            </p>
            <a data-aos="fade" data-aos-delay={100} href="/plans">
              <div className="home-two-btn-bg py-2.5 mt-[40px] group bg-mainBtn border-theme">
                <span className="text-base text-white group-hover:text-[#F30A02] transition-all duration-300 font-semibold py-1 relative z-10">
                  Explore Plans
                </span>
                <svg
                  className="relative z-10"
                  width={7}
                  height={12}
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="group-hover:stroke-[#F30A02] stroke-white transition-all duration-300"
                    d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </a>
          </div>
          <div className="col-span-6 mt-[4rem] md:mt-0">
            <div className="flex w-full relative justify-end">
              <img
                data-aos="fade"
                src="assets/images/about.png"
                alt=""
                className="max-w-full"
              />
              <div
                data-aos="fade"
                data-aos-delay={100}
                className="bg-it-blue p-4 sm:p-[30px] rounded-2xl absolute z-10 bottom-16 left-2 sm:left-0 w-48 sm:w-[295px] max-md:bottom-[-65px] max-md:left-[50%] max-md:translate-x-[-50%]"
              >
                <img
                  src="assets/images/home-five/hero/about-card-shape.webp"
                  alt=""
                  className="absolute right-2 top-bottom-moving"
                />
                <div className="flex items-center gap-2.5">
                  <svg
                    width={11}
                    height={12}
                    viewBox="0 0 11 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.28753 7.01343L8.90454 1.36956M8.90454 1.36956L3.26066 1.75255M8.90454 1.36956L1.01321 10.4099"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="text-sm text-white leading-8">We have</span>
                </div>
                <h1
                  className="text-[27px] leading-[35px] text-white font-semibold tracking-tight max-w-[170px]"
                  data-scroll-qs="scroll"
                  data-count-qs={5}
                  data-type-qs="+ Years of Experience"
                  data-speed-qs={1000}
                >
                  5+ Years of Experience
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* about end  */}

      
        {/* fun fact  start  */}
        {/* <section className="pb-16 md:pb-[130px]">
          <div className="theme-container w-full mx-auto">
            <div className="border border-buisness-dark-black/10 grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 rounded-[15px]">
              <div className="col-span-3 border-r border-buisness-dark-black/10 p-5 md:p-[50px] lg:p-5 xl:p-[50px]">
                <svg
                  width={55}
                  height={55}
                  viewBox="0 0 55 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M50.5702 3.67754C40.352 2.39289 30.3969 6.13063 22.8236 13.3328C11.9614 11.8428 5.21193 20.4967 4.22372 27.5648C4.12359 28.1097 4.62782 28.6325 5.17526 28.5524C5.17525 28.5524 13.3251 27.5623 13.3251 27.5623C13.9035 28.1414 14.6253 28.8598 15.5268 29.7578L14.1332 32.5681C13.6423 33.5601 13.8378 34.7527 14.6208 35.5357L19.464 40.3789C20.2498 41.1655 21.4481 41.355 22.4315 40.8656L25.2379 39.4747C26.3141 40.5511 27.2003 41.4374 27.733 41.9701C28.0034 42.2409 28.4187 42.298 28.751 42.1178C31.4385 40.6571 35.8559 37.9194 40.0917 33.8082C40.5568 42.1317 34.0611 47.604 28.2985 48.8432C28.2986 48.8434 28.678 45.7282 28.678 45.7282C28.7938 44.5988 27.1237 44.4016 26.9726 45.5201C26.9726 45.52 26.4481 49.8253 26.4481 49.8253C26.4154 50.0939 26.5102 50.3616 26.7049 50.5487C26.8994 50.7368 27.1737 50.8208 27.4384 50.7778C34.0938 49.8465 43.1688 43.3912 41.6728 32.1939C48.1362 25.6935 52.837 14.6147 51.3219 4.4294C51.2752 4.03506 50.9647 3.72454 50.5702 3.67754ZM21.6679 39.3257C21.3397 39.4901 20.9403 39.4247 20.6793 39.1637L15.836 34.3205C15.575 34.0595 15.5096 33.6617 15.6732 33.3318L16.8096 31.0391C19.033 33.2668 21.731 35.9667 23.9558 38.1923L21.6679 39.3257ZM49.3559 13.8835C46.7366 28.4769 34.3118 37.0312 28.4908 40.2975C25.6545 37.4628 18.6114 30.4041 14.7022 26.508C15.9672 24.2181 18.0635 21.1172 19.8854 18.9575C20.599 18.0894 19.281 16.9982 18.561 17.8615C16.6575 20.1071 14.3729 23.5087 13.0986 25.8578C13.0986 25.8578 6.1538 26.7019 6.1538 26.7019C6.74881 24.2874 8.57331 19.2445 13.748 16.5296C17.4356 14.5934 21.093 14.7957 22.9452 15.0861C23.2068 15.1185 23.4799 15.0588 23.682 14.8737C30.7628 8.03191 40.0518 4.2962 49.689 5.31075C49.9735 8.21023 49.8619 11.0905 49.3559 13.8835Z"
                    fill="#D90A2C"
                  />
                  <path
                    d="M14.7102 40.3193C8.77683 35.0351 3.52103 45.465 3.43943 50.6485C3.39573 51.1494 3.85145 51.6047 4.35156 51.5608C9.52241 51.48 19.9276 46.2452 14.7102 40.3193ZM13.0905 46.1436C11.7603 47.3302 10.2472 48.2559 8.59471 48.8937C7.51797 49.3083 6.39844 49.5937 5.25372 49.7464C5.63943 46.8342 6.89756 44.0988 8.86494 41.8996C11.9293 38.3159 16.7124 43.0268 13.0905 46.1436Z"
                    fill="#D90A2C"
                  />
                  <path
                    d="M30.3781 14.8551C26.0371 19.1103 29.1825 26.7053 35.2609 26.6438C41.3444 26.6947 44.4769 19.1322 40.1442 14.8551C37.452 12.1629 33.0704 12.1629 30.3781 14.8551ZM38.9291 23.4061C33.9327 28.1075 26.8926 21.064 31.5934 16.0703C36.6199 11.3889 43.6097 18.3803 38.9291 23.4061Z"
                    fill="#D90A2C"
                  />
                </svg>
                <h1
                  className="text-48 font-semibold text-main-black pt-5 md:pt-11"
                  data-scroll-qs="scroll"
                  data-count-qs={28}
                  data-type-qs="K+"
                  data-speed-qs={1000}
                >
                  28k+
                </h1>
                <h2 className="text-18 font-medium text-paragraph pt-2.5">
                  Project Complete
                </h2>
                <p className="text-paragraph leading-[30px] tracking-tight pt-5">
                  Agencies may services related market research, branding
                </p>
              </div>
              
              <div className="col-span-3 border-r border-buisness-dark-black/10 p-5 md:p-[50px] lg:p-5 xl:p-[50px]">
                <svg
                  width={55}
                  height={55}
                  viewBox="0 0 55 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_460_26017)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M17.3348 24.8039C15.8839 23.353 15.159 21.4522 15.159 19.5503C15.159 17.6495 15.8839 15.7476 17.3348 14.2967C17.4976 14.1339 17.6714 13.9766 17.854 13.8248C19.3269 12.6027 21.1485 12.045 22.9393 12.1319C24.707 12.2166 26.4428 12.9283 27.7848 14.2417C29.1466 13.134 30.8065 12.5741 32.4686 12.5686C34.3727 12.562 36.2757 13.2836 37.7343 14.7422C39.1852 16.1931 39.9101 18.0939 39.9101 19.9958C39.9101 21.8966 39.1852 23.7985 37.7343 25.2494L28.2875 34.6962C27.9949 34.9888 27.5208 34.9888 27.2282 34.6962L17.3348 24.8039ZM16.6572 19.5503C16.6572 21.0683 17.2358 22.5863 18.3941 23.7446L27.7573 33.1078L36.675 24.1901C37.8333 23.0318 38.4119 21.5138 38.4119 19.9958C38.4119 18.4778 37.8333 16.9598 36.675 15.8015C35.5068 14.6333 33.9866 14.0558 32.4686 14.0602C30.9517 14.0657 29.4337 14.6553 28.2666 15.8224L28.2655 15.8213C28.249 15.8378 28.2314 15.8532 28.2138 15.8686C27.8959 16.1315 27.424 16.0875 27.16 15.7696C27.0434 15.6288 26.9169 15.4902 26.7805 15.3549C25.7014 14.2758 24.2967 13.6917 22.8689 13.6235C21.44 13.5542 19.9858 13.9997 18.8077 14.9776C18.6702 15.092 18.5316 15.2174 18.3941 15.356C17.2358 16.5143 16.6572 18.0323 16.6572 19.5503ZM26.94 0.766699C26.94 0.353099 27.2755 0.0175991 27.6891 0.0175991C28.1027 0.0175991 28.4382 0.353099 28.4382 0.766699V5.0952C28.4382 5.5088 28.1027 5.8443 27.6891 5.8443C27.2755 5.8443 26.94 5.5088 26.94 5.0952V0.766699ZM53.8438 28.7452C54.2563 28.7452 54.5896 29.0796 54.5896 29.491C54.5896 29.9024 54.2552 30.2368 53.8438 30.2368H49.0599C48.6474 30.2368 48.3141 29.9024 48.3141 29.491C48.3141 29.0796 48.6485 28.7452 49.0599 28.7452H53.8438ZM51.4084 14.3836C51.7637 14.1757 52.2213 14.2945 52.4292 14.6498C52.6382 15.0051 52.5183 15.4627 52.163 15.6706L48.5341 17.7991C48.1788 18.007 47.7212 17.8882 47.5133 17.5329C47.3054 17.1776 47.4242 16.72 47.7795 16.5121L51.4084 14.3836ZM40.9265 4.1162C41.13 3.7576 41.5865 3.6322 41.9451 3.8357C42.3037 4.0392 42.4291 4.4957 42.2256 4.8543L40.1983 8.4348C39.9948 8.7934 39.5383 8.9188 39.1797 8.7153C38.8211 8.5118 38.6957 8.0553 38.8992 7.6967L40.9265 4.1162ZM1.15926 29.5537C0.745656 29.5537 0.410156 29.2182 0.410156 28.8046C0.410156 28.391 0.745656 28.0555 1.15926 28.0555H5.71876C6.13236 28.0555 6.46786 28.391 6.46786 28.8046C6.46786 29.2182 6.13236 29.5537 5.71876 29.5537H1.15926ZM3.30426 15.3274C2.94896 15.1195 2.82906 14.6619 3.03806 14.3066C3.24596 13.9513 3.70356 13.8314 4.05886 14.0404L7.89566 16.291C8.25096 16.5 8.37086 16.9565 8.16186 17.3118C7.95396 17.6671 7.49636 17.787 7.14106 17.578L3.30426 15.3274ZM13.1823 4.741C12.9788 4.3824 13.1042 3.9259 13.4628 3.7224C13.8214 3.5189 14.2779 3.6443 14.4814 4.0029L16.3316 7.2721C16.5351 7.6307 16.4097 8.0872 16.0511 8.2907C15.6925 8.4942 15.236 8.3688 15.0325 8.0102L13.1823 4.741ZM7.39186 42.1509L9.93066 40.9992C10.6842 40.6934 11.4938 40.9255 11.9382 41.6086L11.9756 41.5789C12.255 41.3589 12.5443 41.1235 12.8479 40.8716C17.2666 37.1833 19.2114 37.3791 26.3229 38.093L26.6859 38.1293C27.9256 38.2536 28.6868 38.8135 29.0256 39.5241C29.2005 39.8904 29.2599 40.2853 29.2137 40.6769L29.2115 40.6923L31.5809 39.534C32.517 39.0764 33.4949 38.9796 34.3397 39.1171C35.0712 39.2359 35.7158 39.5373 36.1701 39.9421L37.0061 39.534C37.8553 39.1193 38.7397 39.0005 39.5284 39.0841C40.1059 39.1457 40.6372 39.3173 41.0706 39.5637C41.515 39.8156 41.867 40.1511 42.0793 40.535C43.2618 40.2171 44.3706 40.3546 45.1241 40.744C45.4937 40.9343 45.7918 41.1906 45.9953 41.492C46.2274 41.8374 46.333 42.2301 46.2813 42.6481C46.2032 43.2795 45.7588 43.9329 44.8249 44.4884L38.0973 48.4935C37.7552 48.697 35.5354 49.5176 33.298 50.2689C31.5743 50.8475 29.8132 51.3975 28.8628 51.6087C28.8199 51.6186 28.777 51.6241 28.7341 51.6252L27.9883 51.6582C27.2062 51.6923 26.2679 51.7297 24.3704 51.8078C20.9043 51.9497 16.7661 52.1169 16.1732 52.1411C16.1853 52.3853 16.1413 52.624 16.0489 52.844C15.8905 53.2213 15.588 53.5425 15.1865 53.7251L12.9744 54.7294C12.0108 55.1672 10.9548 55.1199 10.4752 53.9352L6.65156 44.5753C6.43266 44.0396 6.26766 43.6557 6.52946 43.0331C6.68786 42.6547 6.99036 42.3335 7.39186 42.1509ZM12.5465 43.0287L15.6771 50.6924C15.8234 50.6693 15.9631 50.655 16.0951 50.6495C16.6198 50.6286 20.8086 50.4592 24.3099 50.3151C26.1084 50.2414 27.7375 50.1743 28.6043 50.1358C29.5074 49.9279 31.1739 49.4054 32.8228 48.8521C34.9854 48.1261 37.0743 47.3671 37.3361 47.2109L44.0637 43.2058C44.5488 42.9165 44.7699 42.6635 44.7941 42.4655C44.7996 42.4171 44.7853 42.3687 44.7545 42.3214C44.694 42.2323 44.5862 42.1465 44.4388 42.0706C43.8855 41.7857 42.9758 41.7373 41.9902 42.1399C39.3656 43.2113 36.7399 44.2827 34.1153 45.3541C33.639 45.5499 32.1969 45.5191 31.6095 45.5015L31.5534 45.5004C30.8857 45.4806 30.2213 45.4443 29.6988 45.4014C29.129 45.3563 28.6648 45.2991 28.4492 45.2419C25.7003 44.5104 22.9514 43.7789 20.2025 43.0474V43.0463C19.8758 42.9605 19.6382 42.6591 19.6459 42.3071C19.6558 41.8946 19.9979 41.569 20.4093 41.5789L25.6992 41.7043C26.6144 41.7263 27.2568 41.3732 27.5582 40.9244C27.6517 40.7858 27.7089 40.6395 27.7254 40.4987C27.7397 40.3777 27.7254 40.2633 27.6781 40.1654C27.5494 39.897 27.1864 39.6781 26.5374 39.6132L26.1744 39.5769C19.5535 38.9125 17.7418 38.7299 13.8049 42.0156C13.4804 42.2873 13.179 42.5315 12.8974 42.7526C12.7808 42.8494 12.6631 42.9407 12.5465 43.0287ZM10.3443 42.4534L8.00676 43.5149C7.88686 43.5688 7.88796 43.659 7.92756 43.7558L11.8546 53.372C11.9316 53.5216 11.947 53.5535 12.0812 53.4919L14.1613 52.5481C14.8378 52.2412 14.7179 52.382 14.5155 51.7935C13.2725 48.7487 12.0284 45.705 10.7854 42.6602C10.6534 42.3478 10.5511 42.3599 10.3443 42.4534ZM27.1677 43.3565L28.1412 43.6161C28.37 43.5666 28.59 43.5105 28.7836 43.4566C29.0817 43.373 29.3006 43.2993 29.3633 43.2685L34.5905 40.7154C34.4431 40.6626 34.2803 40.6208 34.1054 40.5933C33.5378 40.5009 32.8767 40.5691 32.2365 40.8815L27.1677 43.3565ZM33.5532 43.9692L40.6295 41.0806C40.5514 41.0036 40.4502 40.9299 40.3325 40.8628C40.0718 40.7143 39.7407 40.6098 39.3689 40.5702C38.8398 40.5141 38.2414 40.5955 37.6606 40.8793L31.2762 43.9978C31.8328 44.0198 32.8426 44.077 33.4146 43.9967C33.4608 43.9923 33.5103 43.9857 33.5532 43.9692Z"
                      fill="#D90A2C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_460_26017">
                      <rect width={55} height={55} fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h1
                  className="text-48 font-semibold text-main-black pt-5 md:pt-11"
                  data-scroll-qs="scroll"
                  data-count-qs={35}
                  data-type-qs="K+"
                  data-speed-qs={1000}
                >
                  35k+
                </h1>
                <h2 className="text-18 font-medium text-paragraph pt-2.5">
                  Happy Customers
                </h2>
                <p className="text-paragraph leading-[30px] tracking-tight pt-5">
                  Agencies may services related market research, branding
                </p>
              </div>
              
              <div className="col-span-3 border-r border-buisness-dark-black/10 p-5 md:p-[50px] lg:p-5 xl:p-[50px]">
                <svg
                  width={55}
                  height={55}
                  viewBox="0 0 55 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_460_26023)">
                    <path
                      d="M9.33366 23.5832C12.5837 23.5832 15.2503 20.9165 15.2503 17.6665C15.2503 14.4165 12.5837 11.7498 9.33366 11.7498C6.08366 11.7498 3.41699 14.4165 3.41699 17.6665C3.41699 20.9165 6.08366 23.5832 9.33366 23.5832ZM9.33366 13.4165C11.667 13.4165 13.5837 15.3332 13.5837 17.6665C13.5837 19.9998 11.667 21.9165 9.33366 21.9165C7.00033 21.9165 5.08366 19.9998 5.08366 17.6665C5.08366 15.3332 7.00033 13.4165 9.33366 13.4165Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M54.5003 53.0832L41.0837 27.9998L43.667 24.6665C43.917 24.7498 44.2503 24.8332 44.5837 24.8332C45.0003 24.8332 45.417 24.7498 45.8337 24.4998L48.0837 26.6665C47.917 26.9998 47.8337 27.3332 47.8337 27.6665C47.8337 29.1665 49.0003 30.3332 50.5003 30.3332C52.0003 30.3332 53.167 29.1665 53.167 27.6665C53.167 26.4998 52.417 25.4998 51.3337 25.1665L51.417 18.4165C52.5003 18.0832 53.2503 17.0832 53.2503 15.9165C53.2503 14.4165 52.0837 13.2498 50.5837 13.2498C49.0837 13.2498 47.917 14.4165 47.917 15.9165C47.917 17.0832 48.667 18.0832 49.7503 18.4165L49.667 25.1665C49.5003 25.2498 49.3337 25.3332 49.167 25.4165L47.0003 23.3332C47.167 22.9998 47.2503 22.5832 47.2503 22.1665C47.2503 20.6665 46.0837 19.4998 44.5837 19.4998C43.0837 19.4998 41.917 20.6665 41.917 22.1665C41.917 22.7498 42.0837 23.2498 42.417 23.6665L40.2503 26.4165L37.3337 20.9998C37.167 20.7498 37.0003 20.5832 36.7503 20.5832C36.5003 20.5832 36.2503 20.6665 36.0003 20.8332L30.167 26.9998L25.5003 15.4998V13.4998C26.167 13.8332 26.917 13.9165 27.5837 13.9165C29.0837 13.9165 30.5837 13.3332 31.917 12.7498C34.167 11.8332 36.0003 10.9998 37.917 12.5832C38.5003 12.9998 39.2503 12.6665 39.2503 11.9165V3.9165C39.2503 3.6665 39.167 3.4165 38.917 3.24984C36.2503 0.999837 33.5837 2.1665 31.167 3.08317C29.0837 3.9165 27.2503 4.74984 25.417 3.4165V1.49984C25.417 0.999837 25.0837 0.666504 24.5837 0.666504C24.0837 0.666504 23.7503 0.999837 23.7503 1.49984V15.3332L17.417 27.4998C16.667 25.9998 15.417 24.7498 13.917 23.9165C13.5837 23.7498 13.167 23.8332 12.917 24.0832L9.33366 27.6665L5.83366 24.0832C5.58366 23.8332 5.16699 23.7498 4.83366 23.9165C2.08366 25.3332 0.416992 28.0832 0.416992 31.1665V42.7498C0.416992 43.2498 0.750326 43.5832 1.25033 43.5832H3.25033L2.83366 53.4998C2.83366 53.7498 2.91699 53.9165 3.08366 54.0832C3.25033 54.2498 3.41699 54.3332 3.66699 54.3332H7.00033C7.41699 54.3332 7.75033 54.0832 7.83366 53.6665L9.41699 46.4998L11.0003 53.6665C11.0837 54.0832 11.417 54.3332 11.8337 54.3332H15.167C15.2503 54.3332 15.3337 54.3332 15.417 54.2498C15.5003 54.2498 15.5837 54.3332 15.667 54.3332H40.0003H53.8337C54.167 54.3332 54.417 54.1665 54.5837 53.9165C54.5837 53.6665 54.5837 53.3332 54.5003 53.0832ZM50.5837 28.6665C50.0003 28.6665 49.5837 28.2498 49.5837 27.6665C49.5837 27.0832 50.0003 26.6665 50.5837 26.6665C51.167 26.6665 51.5837 27.0832 51.5837 27.6665C51.5837 28.2498 51.0837 28.6665 50.5837 28.6665ZM50.667 14.8332C51.2503 14.8332 51.667 15.2498 51.667 15.8332C51.667 16.4165 51.2503 16.8332 50.667 16.8332C50.0837 16.8332 49.667 16.4165 49.667 15.8332C49.667 15.3332 50.0837 14.8332 50.667 14.8332ZM44.5837 21.0832C45.167 21.0832 45.5837 21.4998 45.5837 22.0832C45.5837 22.6665 45.167 23.0832 44.5837 23.0832C44.0003 23.0832 43.5837 22.6665 43.5837 22.0832C43.5837 21.5832 44.0003 21.0832 44.5837 21.0832ZM31.917 4.6665C34.0003 3.83317 35.8337 2.99984 37.667 4.33317V10.4165C35.417 9.4165 33.2503 10.3332 31.3337 11.1665C29.2503 11.9998 27.417 12.8332 25.5837 11.4998V5.4165C27.7503 6.4165 29.917 5.49984 31.917 4.6665ZM12.417 52.6665L10.167 42.4998C10.0837 42.1665 9.75033 41.8332 9.33366 41.8332C8.91699 41.8332 8.66699 42.0832 8.58366 42.3332C8.58366 42.3332 8.58366 42.4165 8.50033 42.4165L6.33366 52.6665H4.50033L5.25033 33.2498C5.25033 32.7498 4.91699 32.4165 4.41699 32.4165C4.00033 32.4165 3.58366 32.7498 3.58366 33.2498L3.25033 41.9165H2.08366V31.1665C2.08366 28.9165 3.25033 26.9165 5.08366 25.6665L8.75033 29.3332C8.91699 29.4998 9.08366 29.5832 9.33366 29.5832C9.58366 29.5832 9.75033 29.4998 9.91699 29.3332L13.5837 25.6665C15.417 26.8332 16.5837 28.9165 16.5837 31.1665V41.9165H15.417L15.0837 33.1665C15.0837 32.6665 14.667 32.3332 14.2503 32.3332C13.7503 32.3332 13.417 32.7498 13.417 33.1665C13.667 40.0832 13.917 45.4998 14.167 52.5832H12.417V52.6665ZM39.917 52.6665H15.8337L15.5003 43.5832H17.5003C18.0003 43.5832 18.3337 43.2498 18.3337 42.7498V31.1665C18.3337 30.5832 18.2503 30.0832 18.167 29.5832C18.2503 29.4998 18.2503 29.4165 18.3337 29.4165L24.5837 17.4998C25.5837 19.9998 30.5003 31.8332 30.5003 31.8332C30.667 32.2498 31.167 32.4165 31.5837 32.2498C32.0003 32.0832 32.167 31.5832 32.0003 31.1665L30.8337 28.6665L36.417 22.8332L39.0837 27.9165L33.667 34.9165C33.5837 34.9165 33.5003 34.9998 33.417 34.9998L32.5003 35.5832C32.167 35.4165 31.7503 35.2498 31.417 35.0832L31.2503 33.9998C31.167 33.5832 30.8337 33.3332 30.417 33.3332H27.917C27.5003 33.3332 27.167 33.5832 27.0837 33.9998L26.917 35.0832C26.5003 35.1665 26.167 35.3332 25.8337 35.4998L24.917 34.8332C24.5837 34.5832 24.167 34.6665 23.8337 34.9165L22.0837 36.6665C21.8337 36.9165 21.7503 37.4165 22.0003 37.7498L22.667 38.6665C22.5003 38.9998 22.3337 39.4165 22.167 39.7498L21.0837 39.9998C20.667 40.0832 20.417 40.4165 20.417 40.8332V43.3332C20.417 43.7498 20.667 44.0832 21.0837 44.1665L22.167 44.3332C22.2503 44.7498 22.417 45.0832 22.5837 45.4165L21.917 46.3332C21.667 46.6665 21.7503 47.0832 22.0003 47.4165L23.7503 49.1665C24.0003 49.4165 24.5003 49.4998 24.8337 49.2498L25.7503 48.5832C26.0837 48.7498 26.5003 48.9165 26.8337 49.0832L27.0003 50.1665C27.0837 50.5832 27.417 50.8332 27.8337 50.8332H30.3337C30.7503 50.8332 31.0837 50.5832 31.167 50.1665L31.3337 49.0832C31.7503 48.9998 32.0837 48.8332 32.417 48.6665L33.3337 49.3332C33.667 49.5832 34.0837 49.4998 34.417 49.2498L36.167 47.4998C36.417 47.2498 36.5003 46.7498 36.2503 46.4165L35.667 45.4998C35.8337 45.1665 36.0003 44.7498 36.167 44.4165L37.2503 44.2498C37.667 44.1665 37.917 43.8332 37.917 43.4165V40.9165C37.917 40.4998 37.667 40.1665 37.2503 40.0832L36.167 39.9165C36.0837 39.4998 35.917 39.1665 35.7503 38.8332L36.417 37.9165C36.667 37.5832 36.5837 37.1665 36.3337 36.8332L35.2503 35.7498L40.0837 29.4998L52.5003 52.7498H39.917V52.6665ZM34.5837 37.4998L34.0837 38.2498C33.917 38.4998 33.917 38.9165 34.0837 39.1665C34.417 39.6665 34.5837 40.2498 34.7503 40.8332C34.8337 41.1665 35.0837 41.4165 35.417 41.4998L36.3337 41.6665V42.7498L35.417 42.9165C35.0837 42.9998 34.8337 43.2498 34.7503 43.5832C34.5837 44.1665 34.417 44.6665 34.0837 45.2498C33.917 45.4998 33.917 45.9165 34.0837 46.1665L34.5837 46.9165L33.7503 47.4998L33.0003 46.9998C32.7503 46.8332 32.3337 46.8332 32.0837 46.9998C31.5837 47.3332 31.0003 47.4998 30.417 47.6665C30.0837 47.7498 29.8337 47.9998 29.7503 48.3332L29.5837 49.1665H28.5003L28.3337 48.2498C28.2503 47.9165 28.0003 47.6665 27.667 47.5832C27.0837 47.4165 26.5003 47.2498 26.0003 46.9165C25.7503 46.7498 25.3337 46.7498 25.0837 46.9165L24.417 47.4998L23.667 46.6665L24.167 45.9165C24.3337 45.6665 24.3337 45.2498 24.167 44.9998C23.8337 44.4998 23.5837 43.9165 23.5003 43.3332C23.417 42.9998 23.167 42.7498 22.8337 42.6665L21.917 42.4998V41.4165L22.8337 41.2498C23.167 41.1665 23.417 40.9165 23.5003 40.6665C23.667 40.0832 23.917 39.4998 24.167 38.9998C24.3337 38.7498 24.3337 38.3332 24.167 38.0832L23.667 37.3332L24.417 36.5832L25.167 37.0832C25.417 37.2498 25.7503 37.2498 26.0837 37.0832C26.5837 36.7498 27.167 36.5832 27.7503 36.4165C28.0837 36.3332 28.3337 36.0832 28.417 35.7498L28.5837 34.8332H29.667L29.8337 35.7498C29.917 36.0832 30.167 36.3332 30.5003 36.4165C31.0003 36.4998 31.5003 36.7498 31.917 36.9998L30.7503 38.4998C30.2503 38.2498 29.7503 38.1665 29.167 38.1665C27.0837 38.1665 25.3337 39.9165 25.3337 41.9998C25.3337 44.0832 27.0837 45.8332 29.167 45.8332C31.2503 45.8332 33.0003 44.0832 33.0003 41.9998C33.0003 41.0832 32.667 40.2498 32.0837 39.5832L34.167 36.9165L34.5837 37.4998ZM31.3337 42.0832C31.3337 43.2498 30.3337 44.2498 29.167 44.2498C28.0003 44.2498 27.0003 43.2498 27.0003 42.0832C27.0003 40.9165 28.0003 39.9165 29.167 39.9165C29.3337 39.9165 29.5837 39.9165 29.7503 39.9998L28.5003 41.5832C28.2503 41.9165 28.2503 42.4998 28.667 42.7498C29.7503 43.5832 30.5003 41.4998 31.0837 40.9998C31.167 41.3332 31.3337 41.6665 31.3337 42.0832Z"
                      fill="#D90A2C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_460_26023">
                      <rect width={55} height={55} fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h1
                  className="text-48 font-semibold text-main-black pt-5 md:pt-11"
                  data-scroll-qs="scroll"
                  data-count-qs={30}
                  data-type-qs="+"
                  data-speed-qs={1000}
                >
                  30+
                </h1>
                <h2 className="text-18 font-medium text-paragraph pt-2.5">
                  Expert Team Member
                </h2>
                <p className="text-paragraph leading-[30px] tracking-tight pt-5">
                  Agencies may services related market research, branding
                </p>
              </div>
              
              <div className="col-span-3 p-5 md:p-[50px] lg:p-5 xl:p-[50px]">
                <svg
                  width={55}
                  height={55}
                  viewBox="0 0 55 55"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_460_26033)">
                    <path
                      d="M1.71875 47.2691H3.025C3.11437 47.5234 3.21836 47.7718 3.33352 48.015L2.40969 48.9388C2.24812 49.1004 2.15789 49.3187 2.15789 49.5464C2.15789 49.7741 2.24812 49.9933 2.40969 50.154L4.84516 52.5895C5.16742 52.9117 5.73805 52.9117 6.06031 52.5895L6.985 51.6648C7.2282 51.7808 7.47656 51.883 7.73008 51.9724V53.2812C7.73008 53.7556 8.11508 54.1406 8.58945 54.1406H12.0338C12.5082 54.1406 12.8932 53.7556 12.8932 53.2812V51.9707C13.1459 51.8813 13.3942 51.7782 13.6357 51.663L14.563 52.5903C14.7245 52.7519 14.9428 52.8421 15.1705 52.8421C15.3983 52.8421 15.6174 52.7519 15.7781 52.5903L18.2136 50.1548C18.3752 49.9933 18.4654 49.775 18.4654 49.5473C18.4654 49.3195 18.3752 49.1004 18.2136 48.9397L17.2855 48.0116C17.4006 47.7701 17.5029 47.5226 17.5923 47.2699H18.9062C19.3806 47.2699 19.7656 46.8849 19.7656 46.4105V42.9662C19.7656 42.4918 19.3806 42.1068 18.9062 42.1068H17.5931C17.5037 41.8541 17.4015 41.6066 17.2863 41.3652L18.2145 40.437C18.376 40.2755 18.4663 40.0572 18.4663 39.8295C18.4663 39.6017 18.376 39.3826 18.2145 39.2219L15.779 36.7864C15.4567 36.4641 14.8861 36.4641 14.5638 36.7864L13.6366 37.7137C13.3951 37.5985 13.1467 37.4963 12.8941 37.406V36.0938C12.8941 35.6194 12.5091 35.2344 12.0347 35.2344H8.59031C8.11594 35.2344 7.73094 35.6194 7.73094 36.0938V37.4017C7.47742 37.4911 7.22906 37.5942 6.98586 37.7094L6.06117 36.7847C5.89961 36.6231 5.68133 36.5329 5.45359 36.5329C5.22586 36.5329 5.00672 36.6231 4.84602 36.7847L2.41055 39.2202C2.24898 39.3817 2.15875 39.6 2.15875 39.8277C2.15875 40.0555 2.24898 40.2746 2.41055 40.4353L3.33438 41.3591C3.21836 41.6032 3.11523 41.8516 3.025 42.1059H1.71875C1.24438 42.1059 0.859375 42.4909 0.859375 42.9653V46.4097C0.859375 46.8841 1.24438 47.2691 1.71875 47.2691ZM2.57812 43.8247H3.66008C4.05195 43.8247 4.39398 43.5591 4.49195 43.1802C4.63203 42.6379 4.84687 42.1188 5.13047 41.6384C5.32984 41.3007 5.27484 40.871 4.99813 40.5943L4.23242 39.8286L5.45273 38.6083L6.21844 39.3748C6.4943 39.6516 6.92313 39.7066 7.26258 39.5072C7.74297 39.2245 8.26117 39.0096 8.80344 38.8704C9.18328 38.7724 9.44797 38.4304 9.44797 38.0385V36.9531H11.1736V38.0394C11.1736 38.4312 11.4383 38.7733 11.8173 38.8712C12.3604 39.0122 12.8777 39.227 13.3573 39.5098C13.6941 39.7083 14.1255 39.6541 14.4014 39.3774L15.1697 38.6083L16.39 39.8286L15.62 40.5986C15.3433 40.8753 15.2883 41.305 15.4877 41.6427C15.7695 42.1214 15.9835 42.6388 16.1236 43.1819C16.2216 43.5609 16.5636 43.8264 16.9555 43.8264H18.0469V45.552H16.958C16.5662 45.552 16.2241 45.8167 16.1262 46.1966C15.9861 46.7388 15.7712 47.257 15.4902 47.7357C15.2909 48.0734 15.3459 48.5031 15.6226 48.7798L16.3917 49.549L15.1714 50.7693L14.4031 49.9984C14.1273 49.7217 13.6967 49.6667 13.359 49.8661C12.8803 50.1488 12.3621 50.3637 11.819 50.5046C11.44 50.6026 11.1753 50.9446 11.1753 51.3365V52.4219H9.44969V51.3373C9.44969 50.9455 9.18414 50.6034 8.80516 50.5055C8.26289 50.3654 7.74383 50.1514 7.2643 49.8687C6.92484 49.6702 6.49602 49.7252 6.22016 50.001L5.45445 50.7667L4.23414 49.5464L4.99898 48.7816C5.27656 48.5048 5.3307 48.0752 5.13133 47.7374C4.84773 47.2562 4.63289 46.738 4.49281 46.1957C4.39484 45.8167 4.05281 45.5512 3.66094 45.5512H2.57812V43.8247Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M10.3125 48.9844C12.6818 48.9844 14.6094 47.0568 14.6094 44.6875C14.6094 42.3182 12.6818 40.3906 10.3125 40.3906C7.9432 40.3906 6.01562 42.3182 6.01562 44.6875C6.01562 47.0568 7.9432 48.9844 10.3125 48.9844ZM10.3125 42.1094C11.7339 42.1094 12.8906 43.2661 12.8906 44.6875C12.8906 46.1089 11.7339 47.2656 10.3125 47.2656C8.89109 47.2656 7.73438 46.1089 7.73438 44.6875C7.73438 43.2661 8.89109 42.1094 10.3125 42.1094Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M54.0958 5.38484C53.9936 5.07977 53.7289 4.85633 53.4109 4.8082L50.3017 4.33383L48.9035 1.35437C48.7617 1.05187 48.4583 0.859375 48.1249 0.859375C47.7914 0.859375 47.4881 1.05188 47.3472 1.35352L45.9489 4.33297L42.8397 4.80734C42.5209 4.85633 42.2571 5.07891 42.1548 5.38398C42.0525 5.68906 42.1299 6.0268 42.3542 6.25711L44.6289 8.58859L44.091 11.892C44.0377 12.2169 44.1752 12.5434 44.4442 12.7334C44.7132 12.9224 45.0664 12.9413 45.3551 12.7832L48.1249 11.2518L50.8955 12.7832C51.0253 12.8545 51.1688 12.8906 51.3114 12.8906C51.485 12.8906 51.6586 12.8373 51.8064 12.7334C52.0754 12.5443 52.2129 12.2169 52.1596 11.892L51.6217 8.58859L53.8964 6.25711C54.1216 6.02766 54.1981 5.69078 54.0958 5.38484ZM50.0877 7.7C49.8969 7.89508 49.811 8.16922 49.8548 8.4382L50.1779 10.4225L48.54 9.51758C48.4111 9.44625 48.2675 9.41016 48.124 9.41016C47.9805 9.41016 47.8379 9.44625 47.7081 9.51758L46.0701 10.4225L46.3932 8.4382C46.4371 8.16922 46.3511 7.89508 46.1604 7.7L44.7501 6.25453L46.6596 5.9632C46.9432 5.91937 47.1864 5.73805 47.3076 5.47852L48.1249 3.74172L48.9404 5.47852C49.0625 5.73805 49.3057 5.91937 49.5884 5.9632L51.4979 6.25453L50.0877 7.7Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M40.7148 11.2372C40.2473 11.1659 39.7644 11.2896 39.3914 11.5818L32.6487 16.8566C33.0191 16.1442 33.1902 15.3441 33.1214 14.5243C33.0252 13.3805 32.4889 12.3432 31.6115 11.6024C30.7341 10.8616 29.6229 10.5084 28.4782 10.6038C27.3344 10.7009 26.2971 11.2372 25.5563 12.1138C24.8164 12.9912 24.4615 14.1032 24.5577 15.247C24.6402 16.2164 25.0527 17.0973 25.7059 17.7977C24.7055 18.0452 23.823 18.6373 23.2309 19.4838L16.4598 28.7255C16.0731 29.278 16.0422 29.9845 16.3791 30.5688C16.7151 31.1523 17.3373 31.4772 18.0136 31.4239L20.0727 31.2495C20.5728 31.2073 21.0283 30.9495 21.3093 30.5585L25.3973 25.1805L25.7067 28.8501L23.676 42.7788C22.9094 42.9361 22.1394 43.077 21.3652 43.1853L21.6032 44.8869C24.2999 44.5096 26.9614 43.847 29.5129 42.9163C34.4629 41.1116 38.4194 38.5137 41.4702 35.9055L41.6627 35.848L41.6361 35.7586C44.5795 33.2131 46.666 30.672 47.9645 28.8595C48.1304 28.6275 48.1708 28.3293 48.0719 28.0629C47.974 27.7956 47.7497 27.5945 47.4738 27.5258L46.1487 27.1941L50.9741 24.5137L52.1136 29.6424L50.9758 29.2634C50.6054 29.1397 50.2006 29.2815 49.9866 29.6055L49.844 29.8203C39.0408 46.2679 27.0319 50.2554 18.8592 50.704L18.9529 52.4202C27.4633 51.9527 39.9165 47.8646 51.0566 31.1016L53.0082 31.7522C53.3012 31.851 53.6252 31.7823 53.8555 31.5752C54.0859 31.368 54.1855 31.0527 54.1185 30.751L52.3998 23.0166C52.3413 22.752 52.1609 22.5302 51.9134 22.4194C51.6659 22.3094 51.3814 22.3197 51.1434 22.452L43.409 26.7489C43.1005 26.9199 42.9286 27.2628 42.975 27.6126C43.0205 27.9623 43.2766 28.2485 43.6187 28.3336L45.8058 28.8802C44.6723 30.3462 43.1073 32.1312 41.0938 33.9436L39.5616 28.8037C39.4189 28.362 39.0984 27.9916 38.7005 27.7965L35.1676 25.9566L34.615 21.7559L42.4834 15.7609C43.2113 15.2075 43.378 14.1814 42.8624 13.426L41.869 11.9668C41.6043 11.5766 41.1832 11.3102 40.7148 11.2372ZM28.6226 12.3174C28.6965 12.3114 28.7704 12.308 28.8443 12.308C29.4519 12.308 30.0337 12.5202 30.5029 12.9164C31.0288 13.3607 31.3502 13.9829 31.4087 14.6695C31.4662 15.3562 31.254 16.0239 30.8097 16.5498C30.3654 17.0758 29.7432 17.398 29.0566 17.4556C28.3691 17.5149 27.7022 17.3009 27.1762 16.8566C26.6503 16.4123 26.328 15.7902 26.2705 15.1035C26.151 13.6864 27.2063 12.4369 28.6226 12.3174ZM29.7905 40.9638L31.5788 30.6436L34.7379 32.1767L36.6053 37.4189C34.6141 38.7355 32.3462 39.9566 29.7905 40.9638ZM33.179 20.6912C32.9341 20.8777 32.8077 21.181 32.8473 21.487L33.5227 26.6252C33.5597 26.9027 33.729 27.1459 33.9782 27.2748L37.921 29.3133L39.6673 35.1716C39.1594 35.5859 38.624 35.9966 38.0671 36.404L36.3466 31.5743C36.1885 31.1738 35.8894 30.8498 35.5044 30.6616L31.3047 28.6009C31.0623 28.4823 30.7779 28.4848 30.5355 28.6069C30.2941 28.7298 30.1248 28.9592 30.0792 29.2256L27.9291 41.6367C27.1195 41.9057 26.3014 42.1532 25.4738 42.3663L27.4229 29.0022C27.4323 28.9369 27.4341 28.8716 27.4289 28.8054L26.9227 22.8113C26.8927 22.4563 26.6477 22.1573 26.3066 22.0584C25.9645 21.9579 25.5976 22.0808 25.3827 22.3635L19.9291 29.5384L17.8589 29.7275L24.6299 20.4858C25.0699 19.8576 25.7609 19.4597 26.5257 19.3944L29.2009 19.1684H29.2027L32.6281 18.8788C32.7948 18.8641 32.9538 18.8023 33.0853 18.6991L40.4519 12.9362L41.4462 14.3954L33.179 20.6912Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M3.4375 1.71875H5.15625V3.4375H3.4375V1.71875Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M5.15625 3.4375H6.875V5.15625H5.15625V3.4375Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M1.71875 3.4375H3.4375V5.15625H1.71875V3.4375Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M3.4375 5.15625H5.15625V6.875H3.4375V5.15625Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M10.3125 4.29688H12.0312V6.01562H10.3125V4.29688Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M12.0312 6.01562H13.75V7.73438H12.0312V6.01562Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M8.59375 6.01562H10.3125V7.73438H8.59375V6.01562Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M10.3125 7.73438H12.0312V9.45312H10.3125V7.73438Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M49.8438 48.125H51.5625V49.8438H49.8438V48.125Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M51.5625 49.8438H53.2812V51.5625H51.5625V49.8438Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M48.125 49.8438H49.8438V51.5625H48.125V49.8438Z"
                      fill="#D90A2C"
                    />
                    <path
                      d="M49.8438 51.5625H51.5625V53.2812H49.8438V51.5625Z"
                      fill="#D90A2C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_460_26033">
                      <rect width={55} height={55} fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <h1
                  className="text-48 font-semibold text-main-black pt-5 md:pt-11"
                  data-scroll-qs="scroll"
                  data-count-qs={25}
                  data-type-qs="+"
                  data-speed-qs={1000}
                >
                  25+
                </h1>
                <h2 className="text-18 font-medium text-paragraph pt-2.5">
                  Years Of Experience
                </h2>
                <p className="text-paragraph leading-[30px] tracking-tight pt-5">
                  Agencies may services related market research, branding
                </p>
              </div>
            </div>
          </div>
        </section> */}
        {/* fun fact  end  */}

      {/* service start  */}
      <section className="w-full py-16 md:py-[130px] -top-2/4 bg-black-seo relative overflow-hidden">
        <div>
          <img
            src="./assets/images/home-two/shape-1.svg"
            alt="bg-shape"
            className="absolute bottom-20 moving-anim tran"
          />
        </div>
        {/* animated circle bg  */}
        <div className="absolute -top-1 -left-1 flex justify-center items-center w-2 h-2 z-0">
          <div className="animated_circle bg-white/5" />
          <div className="animated_circle2 bg-white/5" />
          <div className="animated_circle3 bg-white/5" />
          <div className="animated_circle4 bg-white/5" />
        </div>
        {/* animated circle bg  */}
        <div className="theme-container w-full mx-auto relative z-10">
          <div className="w-full flex gap-5 flex-col items-center">
            <p data-aos="fade" className="px-5 py-1 text-white rounded-[30px] bg-blue-seo-1 font-medium">
              Explore More
            </p>
            <h1 data-aos="fade" data-aos-delay={100} className="text-white text-24 md:text-48 font-semibold max-w-[684px] w-full text-center">
              Features of our Health Subscription Plan
            </h1>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-[30px] mt-7 md:mt-[70px]">
            {/* single card start */}
            <div
              data-aos-duration={1000}
              data-aos="fade"
              className="col-span-1 p-5 md:p-[50px] rounded-3xl flex flex-col md:flex-row gap-[50px] relative overflow-hidden group border border-white/5 transition-all duration-300 before:inline-block before:w-[1000px] before:h-[1000px] before:rounded-full before:bg-blue-seo before:absolute before:z-0 z-10 before:-bottom-[1000px] before:-right-[1000px] before:transition-all before:duration-1000 hover:before:-bottom-[300px] hover:before:-right-[100px]"
            >
              {/* animation circle  */}
              <div className="hidden absolute -bottom-1 -right-1 group-hover:flex justify-center items-center w-2 h-2 z-0">
                <div className="animated_circle_sm bg-white/10" />
                <div className="animated_circle_sm2 bg-white/10" />
                <div className="animated_circle_sm3 bg-white/10" />
                <div className="animated_circle_sm4 bg-white/10" />
              </div>
              <div className="relative z-10">
                <svg
                  width={58}
                  height={58}
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M49.292 41.6126L54.5766 46.8972C56.6972 49.0177 56.6972 52.4558 54.5766 54.5763C52.4561 56.6969 49.018 56.6969 46.8975 54.5763L41.6128 49.2918M1.16699 24.5417C1.16699 11.6321 11.6323 1.16675 24.542 1.16675C37.4516 1.16675 47.917 11.6321 47.917 24.5417C47.917 37.4514 37.4516 47.9167 24.542 47.9167C11.6323 47.9167 1.16699 37.4514 1.16699 24.5417Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="relative z-10">
                <h1 className="font-semibold text-22 text-white">
                  Affordable Plans
                </h1>
                <p className="group-hover:text-white text-white/50 transition-all duration-300 mt-4">
                  ClickForDoctor offers affordable subscription plans that
                  provide quality care and essential health coverage without
                  financial stress.
                </p>
              </div>
            </div>
            {/* single card end */}
            {/* single card start */}
            <div
              data-aos-duration={1000}
              data-aos="fade"
              data-aos-delay={100}
              className="col-span-1 p-5 md:p-[50px] rounded-3xl flex flex-col md:flex-row gap-[50px] relative overflow-hidden group border border-white/5 transition-all duration-300 before:inline-block before:w-[1000px] before:h-[1000px] before:rounded-full before:bg-blue-seo before:absolute before:z-0 z-10 before:-bottom-[1000px] before:-right-[1000px] before:transition-all before:duration-1000 hover:before:-bottom-[300px] hover:before:-right-[100px]"
            >
              {/* animation circle  */}
              <div className="hidden absolute -bottom-1 -right-1 group-hover:flex justify-center items-center w-2 h-2 z-0">
                <div className="animated_circle_sm bg-white/10" />
                <div className="animated_circle_sm2 bg-white/10" />
                <div className="animated_circle_sm3 bg-white/10" />
                <div className="animated_circle_sm4 bg-white/10" />
              </div>
              <div className="relative z-10">
                <svg
                  width={58}
                  height={58}
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.25 15.25H42.75M15.25 29H29M40 42.75L48.25 56.5M18 42.75L9.75 56.5M29 42.75V51M48.25 1.5L9.75 1.5C5.19365 1.5 1.5 5.19365 1.5 9.75L1.5 34.5C1.5 39.0563 5.19365 42.75 9.75 42.75L48.25 42.75C52.8063 42.75 56.5 39.0563 56.5 34.5L56.5 9.75C56.5 5.19366 52.8064 1.5 48.25 1.5Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="relative z-10">
                <h1 className="font-semibold text-22 text-white">
                  Wide Range of Plans to Suit Every Need
                </h1>
                <p className="group-hover:text-white text-white/50 transition-all duration-300 mt-4">
                  ClickForDoctor Offers flexible plans tailored to individual
                  and family health needs.
                </p>
              </div>
            </div>
            {/* single card end */}
            {/* single card start */}
            <div
              data-aos-duration={1000}
              data-aos="fade"
              data-aos-delay={100}
              className="col-span-1 p-5 md:p-[50px] rounded-3xl flex flex-col md:flex-row gap-[50px] relative overflow-hidden group border border-white/5 transition-all duration-300 before:inline-block before:w-[1000px] before:h-[1000px] before:rounded-full before:bg-blue-seo before:absolute before:z-0 z-10 before:-bottom-[1000px] before:-right-[1000px] before:transition-all before:duration-1000 hover:before:-bottom-[300px] hover:before:-right-[100px]"
            >
              {/* animation circle  */}
              <div className="hidden absolute -bottom-1 -right-1 group-hover:flex justify-center items-center w-2 h-2 z-0">
                <div className="animated_circle_sm bg-white/10" />
                <div className="animated_circle_sm2 bg-white/10" />
                <div className="animated_circle_sm3 bg-white/10" />
                <div className="animated_circle_sm4 bg-white/10" />
              </div>
              <div className="relative z-10">
                <svg
                  width={56}
                  height={56}
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M41.833 51.0001V41.8334H50.9997"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.16602 14.3331L14.3327 14.3331L14.3327 5.16644"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M34.958 21.2081L21.208 34.9582"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                  <path
                    d="M23.5 14.3333L33.0074 4.82589C35.3505 2.48275 39.1495 2.48275 41.4926 4.82589L51.3407 14.674C53.6839 17.0171 53.6839 20.8161 51.3407 23.1593L41.8333 32.6667"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                  <path
                    d="M32.6661 41.8332L23.1587 51.3406C20.8155 53.6838 17.0165 53.6838 14.6734 51.3406L4.82528 41.4925C2.48213 39.1494 2.48213 35.3504 4.82528 33.0072L14.3327 23.4998"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="relative z-10">
                <h1 className="font-semibold text-22 text-white">
                  Simple and Hassle-Free Claims
                </h1>
                <p className="group-hover:text-white text-white/50 transition-all duration-300 mt-4">
                  ClickForDoctor simplifies claims for fast, hassle-free
                  processing with minimal paperwork and timely reimbursements.
                </p>
              </div>
            </div>
            {/* single card end */}
            {/* single card start */}
            <div
              data-aos-duration={1000}
              data-aos="fade"
              data-aos-delay={100}
              className="col-span-1 p-5 md:p-[50px] rounded-3xl flex flex-col md:flex-row gap-[50px] relative overflow-hidden group border border-white/5 transition-all duration-300 before:inline-block before:w-[1000px] before:h-[1000px] before:rounded-full before:bg-blue-seo before:absolute before:z-0 z-10 before:-bottom-[1000px] before:-right-[1000px] before:transition-all before:duration-1000 hover:before:-bottom-[300px] hover:before:-right-[100px]"
            >
              {/* animation circle  */}
              <div className="hidden absolute -bottom-1 -right-1 group-hover:flex justify-center items-center w-2 h-2 z-0">
                <div className="animated_circle_sm bg-white/10" />
                <div className="animated_circle_sm2 bg-white/10" />
                <div className="animated_circle_sm3 bg-white/10" />
                <div className="animated_circle_sm4 bg-white/10" />
              </div>
              <div className="relative z-10">
                <svg
                  width={58}
                  height={58}
                  viewBox="0 0 58 58"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.58301 14.3333V2.58325C1.58301 2.03097 2.03072 1.58325 2.58301 1.58325H14.333C14.8853 1.58325 15.333 2.03097 15.333 2.58325V14.3333C15.333 14.8855 14.8853 15.3333 14.333 15.3333H2.58301C2.03072 15.3333 1.58301 14.8855 1.58301 14.3333Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M42.833 14.3333V2.58325C42.833 2.03097 43.2807 1.58325 43.833 1.58325H55.583C56.1353 1.58325 56.583 2.03097 56.583 2.58325V14.3333C56.583 14.8855 56.1353 15.3333 55.583 15.3333H43.833C43.2807 15.3333 42.833 14.8855 42.833 14.3333Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M42.833 55.5833V43.8333C42.833 43.281 43.2807 42.8333 43.833 42.8333H55.583C56.1353 42.8333 56.583 43.281 56.583 43.8333V55.5833C56.583 56.1355 56.1353 56.5833 55.583 56.5833H43.833C43.2807 56.5833 42.833 56.1355 42.833 55.5833Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.58301 55.5833V43.8333C1.58301 43.281 2.03072 42.8333 2.58301 42.8333H14.333C14.8853 42.8333 15.333 43.281 15.333 43.8333V55.5833C15.333 56.1355 14.8853 56.5833 14.333 56.5833H2.58301C2.03072 56.5833 1.58301 56.1355 1.58301 55.5833Z"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M23.583 31.8335H34.583"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                  />
                  <path
                    d="M20.833 37.3333L29.083 18.0833L37.333 37.3333"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.333 8.45837H42.833M49.708 15.3334V42.8334M42.833 49.7084H15.333M8.45801 42.8334V15.3334"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div className="relative z-10">
                <h1 className="font-semibold text-22 text-white">
                  Reliable Customer Support
                </h1>
                <p className="group-hover:text-white text-white/50 transition-all duration-300 mt-4">
                  ClickForDoctor skilled support team ensures quick, helpful
                  responses, enhancing your experience.
                </p>
              </div>
            </div>
            {/* single card end */}
          </div>
          {/* case study start  */}
          <div className="pt-16 md:pt-[130px]">
            <p data-aos="fade" className="px-5 py-1 text-white rounded-[30px] bg-blue-seo-1 font-medium w-fit">
              Our Clients
            </p>
            <div className="flex flex-col sm:flex-row w-full justify-between items-end mt-5">
              <h1 data-aos="fade" data-aos-delay={100} className="max-w-[660px] text-24 sm:text-48 text-white font-semibold">
                Not Convinced? Take a look at some of our Clients
              </h1>
            </div>
            <center className="min-md:px-[200px] mt-[80px]">
              <div className="swiper h3-partner_slider mt-11 overflow-hidden">
                <div className="swiper-wrapper">
                  <div className="swiper-slide" data-aos="fade">
                    <img src="assets/images/partner_logo/1.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={100}
                  >
                    <img src="assets/images/partner_logo/2.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={200}
                  >
                    <img src="assets/images/partner_logo/4.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={300}
                  >
                    <img src="assets/images/partner_logo/5.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide" data-aos="fade" data-aos-delay={400}
                  >
                    <img src="assets/images/partner_logo/6.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/7.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/8.svg" alt="" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/9.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/10.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/11.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/12.png" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/13.svg" alt="" className="h-[60px]" />
                  </div>
                  <div
                    className="swiper-slide"data-aos="fade" data-aos-delay={500}
                  >
                    <img src="assets/images/partner_logo/14.png" alt="" className="h-[60px]" />
                  </div>
                </div>
              </div>
            </center>
          </div>
          {/* case study end  */}
        </div>
      </section>
      {/* service end  */}

      {/* service start  */}
      <section className="pt-16 md:pt-[130px]">
        {/* title  */}
        <div className="theme-container mx-auto flex flex-col items-center">
          <h1 data-aos="fade" className="border text-theme border-buisness-red/10 pt-1 py-0.5  px-5 rounded-[30px] w-fit bg-theme font-medium">
            What We Provide
          </h1>
          <h2 data-aos="fade" data-aos-delay={100} className="text-24 sm:text-48 font-semibold text-main-black pt-5 max-w-[692px] text-center">
            Pathways to Progress: Our Mission, Vision, and Goals
          </h2>
        </div>
        {/* services */}
        <div className="relative mt-10 md:mt-[70px] h-fit">
          <div className="w-full h-1/2 bg-white absolute top-0 z-0" />
          <div className="theme-container w-full mx-auto relative z-10">
            <div className="pt-3 pb-[100px] md:pt-10 lg:pt-0 flex items-center gap-5">
              <div className="grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-[30px]">
                {/* single card start  */}
                <div
                  data-aos="fade"
                  className="px-6 py-5 sm:px-[50px] col-span-4 sm:py-10 bg-white rounded-[20px] shadow-card"
                >
                  <div className="p-5 rounded-full bg-buisness-red-1 transition-all duration-300 ease-out w-fit">
                    <svg
                      width={32}
                      height={32}
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_695_40)">
                        <path className="group-hover:stroke-white transition-all duration-300"
                          d="M10 7V5.5C10 3.01472 12.0147 1 14.5 1H17.5C19.9853 1 22 3.01472 22 5.5V7M1 13.5212C1 13.5212 5.67706 16.6367 12.9665 17.3663M31 13.5212C31 13.5212 26.3229 16.6367 19.0335 17.3663M7 31H25C28.3137 31 31 28.3137 31 25V13C31 9.68629 28.3137 7 25 7H7C3.68629 7 1 9.68629 1 13V25C1 28.3137 3.68629 31 7 31Z"
                          stroke="url(#paint0_linear_695_40)"
                          strokeWidth={2}
                          strokeLinecap="round"
                        />
                        <path className="group-hover:stroke-white transition-all duration-300"
                          d="M19 16.2402V17.7402C19 17.7552 19 17.7552 19 17.7702C19 19.4052 18.985 20.7402 16 20.7402C13.03 20.7402 13 19.4202 13 17.7852V16.2402C13 14.7402 13 14.7402 14.5 14.7402H17.5C19 14.7402 19 14.7402 19 16.2402Z"
                          stroke="url(#paint1_linear_695_40)"
                          strokeWidth={2}
                          strokeMiterlimit={10}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_695_40"
                          x1={1}
                          y1={16}
                          x2={31}
                          y2={16}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F30A02" />
                          <stop offset={1} stopColor="#FF6501" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_695_40"
                          x1={13}
                          y1="17.7402"
                          x2={19}
                          y2="17.7402"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F30A02" />
                          <stop offset={1} stopColor="#FF6501" />
                        </linearGradient>
                        <clipPath id="clip0_695_40">
                          <rect width={32} height={32} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <h1 className="text-22 text-main-black font-semibold pt-6">
                    Vision
                  </h1>
                  <p className="text-paragraph pt-3.5">
                    To be the trusted healthcare partner, redefining care through greater awareness, accessibility, and affordability for all.
                  </p>
                </div>
                {/* single card end  */}
                {/* single card start  */}
                <div
                  data-aos="fade"
                  data-aos-delay={100}
                  className="px-6 py-5 sm:px-[50px] col-span-4 sm:py-10 bg-white rounded-[20px] shadow-card"
                >
                  <div className="p-5 rounded-full bg-buisness-red-1 transition-all duration-300 ease-out w-fit">
                    <svg
                      width={32}
                      height={32}
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_695_43)">
                        <path className="group-hover:fill-white transition-all duration-300"
                          d="M16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
                          fill="url(#paint0_linear_695_43)"
                        />
                        <path className="group-hover:stroke-white transition-all duration-300"
                          d="M16 16L31 1M25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16ZM31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z"
                          stroke="url(#paint1_linear_695_43)"
                          strokeWidth={2}
                          strokeLinecap="round"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_695_43"
                          x1={13}
                          y1={16}
                          x2={19}
                          y2={16}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F30A02" />
                          <stop offset={1} stopColor="#FF6501" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_695_43"
                          x1={1}
                          y1={16}
                          x2={31}
                          y2={16}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F30A02" />
                          <stop offset={1} stopColor="#FF6501" />
                        </linearGradient>
                        <clipPath id="clip0_695_43">
                          <rect width={32} height={32} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <h1 className="text-22 text-main-black font-semibold pt-6">
                    Mission
                  </h1>
                  <p className="text-paragraph pt-3.5">
                    Empowering individuals and organizations with accessible, affordable, and personalized healthcare to enhance well-being and quality of life.
                  </p>
                </div>
                {/* single card end  */}
                {/* single card start  */}
                <div
                  data-aos="fade"
                  data-aos-delay={200}
                  className="px-6 py-5 sm:px-[50px] col-span-4 sm:py-10 bg-white rounded-[20px] shadow-card"
                >
                  <div className="p-5 rounded-full bg-buisness-red-1 transition-all duration-300 ease-out w-fit">
                    <svg
                      width={32}
                      height={32}
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_695_46)">
                        <path className="group-hover:fill-white transition-all duration-300"
                          d="M19.75 10.5C19.1977 10.5 18.75 10.9477 18.75 11.5C18.75 12.0523 19.1977 12.5 19.75 12.5V10.5ZM24.1056 14.9472C24.3526 15.4412 24.9532 15.6414 25.4472 15.3944C25.9412 15.1474 26.1414 14.5468 25.8944 14.0528L24.1056 14.9472ZM23.5863 12.7983L24.1346 11.9619L22.4619 10.8654L21.9137 11.7017L23.5863 12.7983ZM6.12148 20.0223C5.85765 20.5075 6.03711 21.1147 6.5223 21.3785C7.0075 21.6423 7.6147 21.4629 7.87852 20.9777L6.12148 20.0223ZM7 2H25V0H7V2ZM30 7V25H32V7H30ZM25 30H7V32H25V30ZM2 25V7H0V25H2ZM7 30C4.23858 30 2 27.7614 2 25H0C0 28.866 3.13401 32 7 32V30ZM30 25C30 27.7614 27.7614 30 25 30V32C28.866 32 32 28.866 32 25H30ZM25 2C27.7614 2 30 4.23858 30 7H32C32 3.13401 28.866 0 25 0V2ZM7 0C3.13401 0 0 3.13401 0 7H2C2 4.23858 4.23858 2 7 2V0ZM19.75 12.5H22.573V10.5H19.75V12.5ZM23.0202 12.7764L24.1056 14.9472L25.8944 14.0528L24.809 11.882L23.0202 12.7764ZM22.573 12.5C22.7623 12.5 22.9355 12.607 23.0202 12.7764L24.809 11.882C24.3855 11.035 23.5199 10.5 22.573 10.5V12.5ZM21.9137 11.7017L17.8103 17.961L19.4829 19.0575L23.5863 12.7983L21.9137 11.7017ZM16.9644 17.9458L14.1022 13.2173L12.3912 14.2529L15.2535 18.9815L16.9644 17.9458ZM9.76714 13.3176L6.12148 20.0223L7.87852 20.9777L11.5242 14.273L9.76714 13.3176ZM14.1022 13.2173C13.1028 11.5663 10.689 11.6222 9.76714 13.3176L11.5242 14.273C11.7086 13.9339 12.1913 13.9227 12.3912 14.2529L14.1022 13.2173ZM17.8103 17.961C17.6086 18.2687 17.1549 18.2605 16.9644 17.9458L15.2535 18.9815C16.206 20.5551 18.4745 20.5959 19.4829 19.0575L17.8103 17.961Z"
                          fill="url(#paint0_linear_695_46)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_695_46"
                          x1={0}
                          y1={16}
                          x2={32}
                          y2={16}
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#F30A02" />
                          <stop offset={1} stopColor="#FF6501" />
                        </linearGradient>
                        <clipPath id="clip0_695_46">
                          <rect width={32} height={32} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <h1 className="text-22 text-main-black font-semibold pt-6">
                    Goals
                  </h1>
                  <p className="text-paragraph pt-3.5">
                    Customer Focus, Ethical Business Practices, Instant and Accurate Decision-Making, and Customer Satisfaction.
                  </p>
                </div>
                {/* single card end  */}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* service end */}

      

  {/* blog start  */}
  <section className="bg-white blogs w-full py-16 md:pt-[60px] pb-[180px] overflow-hidden">
    <div className="theme-container w-full mx-auto">
      <div className="max-w-[777px] w-full flex flex-col items-center mx-auto">
       <h1 data-aos="fade" className="border text-theme border-buisness-red/10 pt-1 py-0.5  px-5 rounded-[30px] w-fit bg-theme font-medium">
            Our Blogs
          </h1>
        <h2 data-aos="fade" data-aos-delay={100} className="text-24 sm:text-48 font-semibold text-main-black pt-5 text-center">
          Read and explore Our latest news
        </h2>
      </div>
      <div className="grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-[30px] mt-10 md:mt-[70px]">
        {/* card start  */}
        <div
          data-aos="fade"
          data-aos-duration={1000}
          className="col-span-4 bg-white"
        >
          <img
            src="assets/images/home-three/blogs/1.jpg"
            alt=""
            className="w-full max-w-[410px] object-cover"
          />
          <div className="flex w-full items-center py-4 gap-5">
            <p className="text-paragraph hover:text-buisness-red font-semibold transition-all duration-300 cursor-pointer">
              Health and Wellness
            </p>
            <span className="w-[5px] h-[5px] rounded-full bg-buisness-red" />
            <p className="text-paragraph">May 14, 2025</p>
          </div>
          <hr className="border-purple/10" />
          <h3 className="case_card_title text-black text-20 sm:text-24 font-semibold pt-4">
             Wellness OPD: Your First Step to Preventive Healthcare 
          </h3>
          <Link to="/wellness-opd-your-first-step-to-preventive-healthcare" >
            <div className="flex items-center gap-2 group mt-4 w-fit">
              <span className="font-medium group-hover:text-buisness-red transition-all duration-300 text-paragraph leading-5 font-inter border-b border-transparent before:inline-block before:border-buisness-red before:border-b before:absolute before:bottom-0 before:transition-all before:duration-300 before:w-0 group-hover:before:w-full before:overflow-hidden before:h-5 relative">
                Read More
              </span>
              <svg
                width={7}
                height={11}
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="stroke-paragraph group-hover:stroke-buisness-red transition-all duration-300"
                  d="M1.5 10L5.29289 6.20711C5.62623 5.87377 5.79289 5.70711 5.79289 5.5C5.79289 5.29289 5.62623 5.12623 5.29289 4.79289L1.5 1"
                  stroke="#ffff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>
        </div>
        {/* card end  */}
        {/* card start  */}
        <div
          data-aos="fade"
          data-aos-duration={1000}
          data-aos-delay={100}
          className="col-span-4 bg-white"
        >
          <img
            src="assets/images/home-three/blogs/2.jpg"
            alt=""
            className="w-full max-w-[410px] object-cover"
          />
          <div className="flex w-full items-center py-4 gap-5">
            <p className="text-paragraph hover:text-buisness-red font-semibold transition-all duration-300">
              Health and Wellness
            </p>
            <span className="w-[5px] h-[5px] rounded-full bg-buisness-red" />
            <p className="text-paragraph">May 14, 2025</p>
          </div>
          <hr className="border-purple/10" />
          <h3 className="case_card_title text-black text-20 sm:text-24 font-semibold pt-4">
              Why Wellness OPD Plans Are a Smart Investment
          </h3>
          <Link to="/why-wellness-opd-plans-are-a-smart-investment">
            <div className="flex items-center gap-2 group mt-4 w-fit">
              <span className="font-medium group-hover:text-buisness-red transition-all duration-300 text-paragraph leading-5 font-inter border-b border-transparent before:inline-block before:border-buisness-red before:border-b before:absolute before:bottom-0 before:transition-all before:duration-300 before:w-0 group-hover:before:w-full before:overflow-hidden before:h-5 relative">
                Read More
              </span>
              <svg
                width={7}
                height={11}
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="stroke-paragraph group-hover:stroke-buisness-red transition-all duration-300"
                  d="M1.5 10L5.29289 6.20711C5.62623 5.87377 5.79289 5.70711 5.79289 5.5C5.79289 5.29289 5.62623 5.12623 5.29289 4.79289L1.5 1"
                  stroke="#ffff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>
        </div>
        {/* card end  */}
        {/* card start  */}
        <div
          data-aos="fade"
          data-aos-duration={1000}
          data-aos-delay={200}
          className="col-span-4 bg-white"
        >
          <img
            src="assets/images/home-three/blogs/3.jpg"
            alt=""
            className="w-full max-w-[410px] object-cover"
          />
          <div className="flex w-full items-center py-4 gap-5">
            <p className="text-paragraph hover:text-buisness-red font-semibold transition-all duration-300">
              Health and Wellness
            </p>
            <span className="w-[5px] h-[5px] rounded-full bg-buisness-red" />
            <p className="text-paragraph">May 14, 2025</p>
          </div>
          <hr className="border-purple/10" />
          <h3 className="case_card_title text-black text-20 sm:text-24 font-semibold pt-4">
              Simplify Your Health Journey with Wellness OPD
          </h3>
           <Link to="/simplify-your-health-journey-with-wellness-opd">
            <div className="flex items-center gap-2 group mt-4 w-fit">
              <span className="font-medium group-hover:text-buisness-red transition-all duration-300 text-paragraph leading-5 font-inter border-b border-transparent before:inline-block before:border-buisness-red before:border-b before:absolute before:bottom-0 before:transition-all before:duration-300 before:w-0 hover:before:w-full before:overflow-hidden before:h-5 relative">
                Read More
              </span>
              <svg
                width={7}
                height={11}
                viewBox="0 0 7 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="stroke-paragraph group-hover:stroke-buisness-red transition-all duration-300"
                  d="M1.5 10L5.29289 6.20711C5.62623 5.87377 5.79289 5.70711 5.79289 5.5C5.79289 5.29289 5.62623 5.12623 5.29289 4.79289L1.5 1"
                  stroke="#ffff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>
        </div>
        {/* card end  */}
      </div>
    </div>
  </section>
  {/* blog end  */}







  

      

      {/* Testimonials start  */}
      {/* <section className="py-[70px] sm:py-[130px] bg-it-gray">
        <div className="theme-container w-full mx-auto">
          <div className="grid grid-cols-6 items-center lg:grid-cols-12 gap-y-10">
            <div className="col-span-6">
              <h1
                data-aos="fade"
                className="border text-[#1D109E] border-[#1D109E11] py-0.5 px-5 rounded-[30px] w-fit bg-main-gray font-medium"
              >
                Our Testimonials
              </h1>
              <h2
                data-aos="fade"
                data-aos-delay={100}
                className="text-24 sm:text-48 font-semibold text-black pt-5 max-w-[457px]"
              >
                Customer Say About Our Services
              </h2>
              <p
                data-aos="fade"
                data-aos-delay={200}
                className="text-18 text-paragraph pt-5"
              >
                We’ve 1k+ Happy Customers
              </p>
            </div>
            <div className="col-span-6 flex flex-col items-start justify-start relative max-w-[502px]">
              <div
                data-aos="fade"
                data-aos-delay={100}
                className="swiper overflow-hidden h3-testimonial-slider w-full h-full"
              >
                <div className="swiper-wrapper">
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/vikram.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Ashish Mehta,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Bangalore
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        The customer support is exceptional, and the platform is
                        so easy to use. I feel confident knowing my health is in
                        good hands.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 md:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Effortless healthcare
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/karan.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Rahul Gupta,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Chandigarh
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        I’m impressed by their dedication to making healthcare
                        affordable. Their OPD plans fit perfectly within my
                        budget, without compromising quality.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Doctor in minutes
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/sneha.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Neha Gujral,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Jaipur
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        Their OPD coverage is a lifesaver. I’ve saved so much on
                        regular doctor visits and diagnostic tests. Thank you
                        for this amazing service!
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Super fast service
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide flex flex-col justify-between">
                    <div>
                      <div className="flex gap-6 items-center">
                        <div className="flex min-w-12 w-12 sm:w-[60px] min-h-12 h-12 sm:h-[60px] rounded-full overflow-hidden">
                          <img
                            className="w-full object-cover"
                            src="assets/images/pooja.png"
                            alt=""
                          />
                        </div>
                        <h1 className="text-20 font-semibold text-main-black">
                          Pooja Verma,{" "}
                          <span className="text-sm font-medium text-paragraph">
                            Delhi
                          </span>
                        </h1>
                      </div>
                      <h1 className="text-[16px] text-paragraph pt-[30px]">
                        From consultations to diagnostics, everything is
                        hassle-free. It’s so convenient, especially when you
                        have kids at home.
                      </h1>
                    </div>
                    <div className="flex justify-between items-center mt-5 sm:mt-10">
                      <svg
                        width={54}
                        height={40}
                        viewBox="0 0 54 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M49.5406 4.06287C47.1408 1.36698 44.2282 0 40.8838 0C37.8781 0 35.33 1.07033 33.3098 3.18112C31.3024 5.27842 30.2845 7.88345 30.2845 10.924C30.2845 13.7974 31.3127 16.3578 33.3404 18.5344C35.129 20.4545 37.3822 21.6759 40.0496 22.1736C39.5831 25.7101 36.4568 28.9111 30.7387 31.7003L29.709 32.2026L33.9307 39.9964L34.8837 39.5134C46.976 33.3839 53.1072 24.7214 53.1072 13.7664C53.1072 9.98687 51.9073 6.72226 49.5406 4.06287ZM34.8388 37.062L32.7236 33.1576C39.0843 29.8246 42.3069 25.8181 42.3069 21.2372V20.2564L41.3324 20.146C38.7077 19.849 36.6191 18.8322 34.9474 17.0374C33.2877 15.2557 32.4808 13.2562 32.4808 10.924C32.4808 8.43381 33.2711 6.39791 34.8964 4.69953C36.5086 3.01495 38.4672 2.19605 40.8839 2.19605C43.6124 2.19605 45.9074 3.28432 47.9 5.5229C49.9262 7.79943 50.9111 10.4958 50.9111 13.7663C50.9111 18.7872 49.4973 23.3202 46.7091 27.2392C44.0485 30.9785 40.0582 34.2797 34.8388 37.062Z"
                          fill="#794AFF"
                        />
                        <path
                          d="M19.7738 4.0579C17.3473 1.36532 14.4226 0 11.0807 0C8.07213 0 5.53555 1.0723 3.54187 3.18703C1.5653 5.2835 0.563015 7.88657 0.563015 10.924C0.563015 13.7973 1.59113 16.3577 3.61863 18.5344C5.40351 20.4504 7.62964 21.6706 10.2474 22.1706C9.78658 25.7098 6.68627 28.9124 1.01401 31.7021L0 32.2006L4.1166 40L5.07906 39.5144C17.2262 33.3852 23.3853 24.7223 23.3853 13.7663C23.3852 9.98387 22.17 6.71749 19.7738 4.0579ZM5.04711 37.0583L2.98964 33.1599C9.30416 29.8257 12.5037 25.8182 12.5037 21.2371V20.2585L11.5314 20.1463C8.96052 19.8496 6.89766 18.8327 5.22542 17.0373C3.56573 15.2558 2.75906 13.2561 2.75906 10.924C2.75906 8.4306 3.53782 6.39252 5.13964 4.69362C6.72402 3.01308 8.6675 2.19605 11.0807 2.19605C13.8119 2.19605 16.122 3.28588 18.1422 5.52798C20.1925 7.80328 21.1892 10.4981 21.1892 13.7663C21.1892 18.7864 19.7692 23.3188 16.9683 27.2374C14.2963 30.9756 10.2888 34.2763 5.04711 37.0583Z"
                          fill="#794AFF"
                        />
                      </svg>
                      <div className="flex gap-2 sm:gap-4 items-center">
                        <h1 className="text-18 font-semibold text-main-black">
                          Seamless experience
                        </h1>
                        <div className="flex gap-1 sm:gap-2.5">
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                          <svg
                            width={15}
                            height={15}
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.02461 0.953559C6.62812 -0.317851 8.37187 -0.317854 8.97539 0.953557L10.0184 3.15088C10.2581 3.65576 10.7213 4.0057 11.2572 4.08666L13.5895 4.43902C14.939 4.6429 15.4779 6.36716 14.5013 7.35681L12.8137 9.06719C12.4259 9.46019 12.249 10.0264 12.3405 10.5813L12.7389 12.9964C12.9694 14.3938 11.5587 15.4595 10.3517 14.7997L8.26562 13.6595C7.78631 13.3975 7.21369 13.3975 6.73438 13.6595L4.64832 14.7997C3.44129 15.4595 2.03057 14.3938 2.26109 12.9964L2.65949 10.5813C2.75103 10.0264 2.57408 9.46019 2.18631 9.06719L0.498656 7.35681C-0.47785 6.36716 0.0609962 4.6429 1.4105 4.43902L3.74278 4.08666C4.27867 4.0057 4.74192 3.65576 4.98158 3.15088L6.02461 0.953559Z"
                              fill="#FF8B33"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Testimonials end  */}
    </main>
  );
};

export default HomePage;
